import React from "react";
import { ResponsiveBar } from "@nivo/bar";
import { styled } from "@mui/system";

const RootStyle = styled("div")({
  height: "300px",
  width: "100%",
});

function WeeklySales({ sales, type, totalColor }) {
  console.log('sales',sales)
  const data = [
    {
      day: "Sunday",
      [type]: sales?.sun?.total,
      Profit: sales?.sun?.profit || 0,
      loss: sales?.sun?.loss || 0,
      color: "#bebebe",
    },
    {
      day: "Monday",
      [type]: sales?.mon?.total,
      Profit: sales?.mon?.profit || 0,
      loss: sales?.mon?.loss || 0,
      color: "#bebebe",
    },
    {
      day: "Tuesday",
      [type]: sales?.tue?.total || 0,
      Profit: sales?.tue?.profit || 0,
      loss: sales?.tue?.loss || 0,
      color: "#bebebe",
    },
    {
      day: "Wednesday",
      [type]: sales?.wed?.total,
      Profit: sales?.wed?.profit || 0,
      loss: sales?.wed?.loss || 0,
      color: "#bebebe",
    },
    {
      day: "Thursday",
      [type]: sales?.thur?.total,
      Profit: sales?.thur?.profit || 0,
      loss: sales?.thur?.loss || 0,
      color: "#bebebe",
    },
    {
      day: "Friday",
      [type]: sales?.fri?.total,
      Profit: sales?.fri?.profit || 0,
      loss: sales?.fri?.loss || 0,
      color: "#bebebe",
    },
    {
      day: "Saturday",
      [type]: sales?.sat?.total,
      Profit: sales?.sat?.profit || 0,
      loss: sales?.sat?.loss || 0,
      color: "#bebebe",
    },
    {},
    {},
    {},
  ];

  return (
    <RootStyle>
      <ResponsiveBar
        data={data}
        keys={[type, "Profit", "loss"]}
        indexBy="day"
        margin={{ top: 5, right: 60, bottom: 50, left: 60 }}
        padding={0.9}
        colors={[totalColor, "#4CAF50", "#e50000"]}
        fill={[]}
        borderColor={{ from: "color", modifiers: [["darker", "1.4"]] }}
        enableGridY={false}
        labelSkipWidth={11}
        labelSkipHeight={12}
        labelTextColor={{ from: "color", modifiers: [["darker", 1.6]] }}
        legends={[
          {
            dataFrom: "keys",
            anchor: "bottom-right",
            direction: "column",
            justify: false,
            translateX: 80,
            translateY: -65,
            itemsSpacing: 2,
            itemWidth: 102,
            itemHeight: 20,
            itemDirection: "left-to-right",
            itemOpacity: 0.85,
            symbolSize: 20,
            effects: [
              {
                on: "hover",
                style: {
                  itemOpacity: 1,
                },
              },
            ],
          },
        ]}
      />
    </RootStyle>
  );
}

export default WeeklySales;
